module.exports = __webpack_public_path__ + "media/4.ba982e36.mp3";